import { ApiError } from '@solante/shared';

const determineApiBaseUrl = () => {
  const envUrl = import.meta.env.VITE_SERVER_PUBLIC_URL?.trim();
  if (envUrl && envUrl.length > 0) {
    return envUrl.replace(/\/$/, '');
  }
  if (typeof window !== 'undefined') {
    return `${window.location.origin.replace(/\/$/, '')}/api`;
  }
  return 'http://localhost:8787/api';
};

const API_BASE_URL = determineApiBaseUrl();

const buildUrl = (path: string) => {
  return `${API_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;
};

const handleResponse = async <T>(response: Response): Promise<T> => {
  if (!response.ok) {
    const payload = (await response.json().catch(() => undefined)) as ApiError | undefined;
    const message = payload?.message || `Request failed with status ${response.status}`;
    throw new Error(message);
  }
  return (await response.json()) as T;
};

export const http = {
  get: async <T>(path: string) => {
    const response = await fetch(buildUrl(path), {
      credentials: 'include',
    });
    return handleResponse<T>(response);
  },
  post: async <T>(path: string, body: unknown) => {
    const response = await fetch(buildUrl(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(body),
    });
    return handleResponse<T>(response);
  },
  delete: async <T>(path: string) => {
    const response = await fetch(buildUrl(path), {
      method: 'DELETE',
      credentials: 'include',
    });
    return handleResponse<T>(response);
  },
};
